'use strict';

function albumViewDirective() {
  return {
    replace: true,
    template: '<div class="line-component--omega album__view">' +
                '<div class="cf">' +
                  '<button ng-repeat="v in views"' +
                           'type="button"' +
                           'ng-click="switchView(v)"' +
                           'class="icon-only line--component"' +
                           'ng-class="{\'active\': albumTemplate == v.template}">' +
                      '<i class="fa fa-2x" ng-class="v.icon"></i>' +
                  '</button>' +
                '</div>' +
              '</div>',
    link: function(scope, elm, attrs) {
      scope.isCollabration = false;
      if (attrs && attrs.isCollabration) {
        scope.isCollabration = true;
      }
      scope.views = [{
        name: 'Grid',
        template: 'partials/company/publications/detail/latest/album-view/grid.html',
        icon: 'fa-th-large '
      }, {
        name: 'List',
        template: 'partials/company/publications/detail/latest/album-view/list.html',
        icon: 'fa-list'
      }];
    },
    controller: ['$scope', '$window', '$stateParams', function($scope, $window, $stateParams) {
      $scope.albumTemplate = 'partials/company/publications/detail/latest/album-view/grid.html';
      if ($window.localStorage["albumView" + $stateParams.publicationId]) {
        $scope.albumTemplate = JSON.parse($window.localStorage["albumView" + $stateParams.publicationId]);
      }

      $scope.switchView = function(view) {
        $scope.albumTemplate = view.template;
        $window.localStorage["albumView" + $stateParams.publicationId] = JSON.stringify(view.template);
      };
    }]
  };
}

angular.module('dokiv')
  .directive('albumView', [albumViewDirective]);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/albumViewDirective.js
// module id = 393
// module chunks = 0